/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetMetricEventDefinitionInstancesByDataSourcePathParams = NonNullable<
  operations['getMetricEventDefinitionInstancesByDataSource']['parameters']['path']
>;

export interface Input extends GetMetricEventDefinitionInstancesByDataSourcePathParams {
  apiVersion?: string;
}

export async function getMetricEventDefinitionInstancesByDataSource(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/environments/{environmentKey}/metric-data-sources/{dataSourceKey}/metric-events/{eventKind}/{eventKey}/instances',
    {
      params: { path },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
